/**
 * Outline "Coming Soon" pill shown on pre-launch sections (US Products +
 * Magazine). Sized on the 1920 frame in vw so it scales with the section.
 */
export const ComingSoonPill = () => (
    <span className="inline-flex w-fit items-center justify-center whitespace-nowrap rounded-full border border-black font-sans font-normal tracking-[-0.03em] text-black max-md:px-7 max-md:py-3 max-md:text-sm md:h-[3.125vw] md:px-[1.436vw] md:text-[1.182vw]">
        Coming Soon - Fall 2026
    </span>
);
